var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Oidc from 'oidc-client';
const defaultConfig = {
    "response_type": "id_token token",
    "scope": "openid profile",
    "filterProtocolClaims": true,
    "stopCheckSessionOnError": false,
    "loadUserInfo": true
};
function parseBaseUrl(url) {
    const matches = url.match(/^(https?\:\/\/[^\/?#]+)(?:[\/?#]|$)/i);
    return matches && `${matches[1]}/`;
}
export default class AuthService {
    constructor() {
        this.userManager = null;
        this.config = null;
    }
    init(config) {
        return __awaiter(this, void 0, void 0, function* () {
            if (config) {
                this.config = Object.assign({}, defaultConfig, config);
                if (!config.scope) {
                    this.config.scope = defaultConfig.scope;
                }
                const { mountpoint } = this.config;
                this.config.post_logout_redirect_uri = parseBaseUrl(mountpoint);
                this.config.redirect_uri = `${mountpoint}/oidc/callback`;
                this.config.silent_redirect_uri = `${mountpoint}/oidc/callback-silent`;
            }
            else {
                const res = yield fetch('/oidc/implicit/config');
                this.config = yield res.json();
            }
            this.config.stateStore = new Oidc.WebStorageStateStore({ store: window.sessionStorage });
            this.userManager = new Oidc.UserManager(this.config);
        });
    }
    isLoggedIn() {
        return __awaiter(this, void 0, void 0, function* () {
            const user = yield this.userManager.getUser();
            return user != null && !user.expired;
        });
    }
    signIn() {
        return __awaiter(this, void 0, void 0, function* () {
            const user = yield this.userManager.getUser();
            if (!user) {
                yield this.userManager.signinRedirect();
            }
            return user;
        });
    }
    completeAuthentication() {
        return __awaiter(this, void 0, void 0, function* () {
            const user = yield this.userManager.signinRedirectCallback();
            return user;
        });
    }
    getUser() {
        return __awaiter(this, void 0, void 0, function* () {
            const user = yield this.userManager.getUser();
            return user;
        });
    }
    getUserJwtToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const user = yield this.userManager.getUser();
            if (user != null) {
                return user.access_token;
            }
            return '';
        });
    }
    removeUser() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.userManager.removeUser();
        });
    }
    signOutSilent({ privateDispatch }) {
        return __awaiter(this, void 0, void 0, function* () {
            const signoutArgs = {
                id_token_hint: '',
            };
            try {
                const user = yield this.userManager.getUser();
                if (user)
                    signoutArgs.id_token_hint = user.id_token;
                else
                    console.log('no id_token_hint for signOutSilent()');
                yield this.userManager._signoutStart(signoutArgs, this.userManager._iframeNavigator);
            }
            catch (err) {
                console.error('AuthService: error during signOutSilent()', err);
                yield this.userManager.removeUser();
            }
            finally {
                privateDispatch({ type: 'LOGOUT', message: 'signOutSilent complete, ensure local signout' });
            }
        });
    }
    signOut() {
        return __awaiter(this, void 0, void 0, function* () {
            const signoutArgs = { id_token_hint: '' };
            try {
                if (yield this.isLoggedIn()) {
                    const user = yield this.getUser();
                    signoutArgs.id_token_hint = user.id_token;
                }
                else {
                    console.warn('oidc-client does not see user as logged in; redirect after logout will go to default');
                }
                yield this.userManager.removeUser();
                return this.userManager.signoutRedirect(signoutArgs);
            }
            catch (err) {
                console.error('AuthService: error during signOut()', err);
            }
        });
    }
}
